import { ComplexValue } from 'app/types-shared';
import { serializeCodes } from 'app/area/search-filters/serialize/serialize';
import { SerializePayload } from 'app/area/search-filters/types';
import { filterId, predefinedFiltersId, queryFilters } from './constants';
import { TextSearchModel } from './types-store';
import { FilterPayloadValues, PredefinedIds } from 'app/area/search-filters/filters/types';
import { FilterCommonTypes } from 'app/area/search-filters/types-store';

const serializeQuery = (query: string, value: ComplexValue<number | string>[]) => {

  const searchInText = (value || []).some(v => v.value === queryFilters.text);
  const searchInOriginalText = (value || []).some(v => v.value === queryFilters.originalText);

  return query && query.trim().length &&
    (searchInText || searchInOriginalText)
    ? {
      [filterId.query]: {
        text: query.trim(),
        searchInText,
        searchInOriginalText
      }
    }
    : {};
};

const serializePredefined = (
  formValues: FilterPayloadValues<FilterCommonTypes>
) => {

  const include = formValues && formValues[PredefinedIds.include] || [];

  return {
    [filterId.potentiallyUntranslatedOnly]: {
      enabled: include.some(i => i.value === predefinedFiltersId.potentiallyUntranslated)
    }
  };
};

export const serialize = (payload: SerializePayload): TextSearchModel => {
  const { query, queryValues, formValues, menuValues, filters, filterValidation } = payload;
  return {
    ...serializeQuery(query, queryValues),
    ...serializePredefined(formValues),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };
};
